import { render, staticRenderFns } from "./ModalBooksCurrent.vue?vue&type=template&id=16a4867e&scoped=true&"
import script from "./ModalBooksCurrent.vue?vue&type=script&lang=js&"
export * from "./ModalBooksCurrent.vue?vue&type=script&lang=js&"
import style0 from "./ModalBooksCurrent.vue?vue&type=style&index=0&id=16a4867e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4867e",
  null
  
)

export default component.exports